import { Button } from '@components/buttons';
import { IconButton } from '@hyperflake/react-ui-library';
import { GlobeIcon } from '@icon/index';
import useFloorPlanDefaultView from 'modules/projects/hooks/useFloorPlanDefaultView';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import FloorPlanGuiViewer from 'modules/site-walk-gui/components/FloorPlanGuiViewer/FloorPlanGuiViewer';
import FloorPlanList from 'modules/site-walk/components/FloorPlanList/FloorPlanList';
// import FloorPlanList from 'modules/site-walk-gui/components/FloorPlanList/FloorPlanList';
import { Link } from 'react-router-dom';
import { twJoin } from 'tailwind-merge';

const FloorPlanGuiListPage = () => {
    const { isDefaultView, isGuiView, toggleView } = useFloorPlanDefaultView();
    return (
        <PageTemplate>
            <div className="flex justify-between items-center">
                <PageHeading className="">
                    <div>Floor Plan List</div>
                </PageHeading>
                <div className="flex justify-between items-center gap-3">
                    <Link to={`add-floor-plan`}>
                        <Button>Add Floor Plan</Button>
                    </Link>
                    <IconButton
                        className={twJoin(
                            'relative text-white transition-all duration-200',
                            !isGuiView
                                ? 'bg-primary border-primary shadow-lg '
                                : 'bg-primary border-primary hover:shadow-md ring-4 ring-primary/50 animate-pulse'
                        )}
                        onClick={() => toggleView()}
                    >
                        <GlobeIcon />
                    </IconButton>
                </div>
            </div>
            {isDefaultView ? <FloorPlanList /> : <FloorPlanGuiViewer />}
        </PageTemplate>
    );
};

export default FloorPlanGuiListPage;
